var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5.35C21.7 5.55 20.6 5.95 19.7 6.05C20.3 5.65 21.2 4.55 21.4 3.65C20.8 4.05 19.5 4.65 18.8 4.65C18 3.85 17 3.25 15.8 3.25C13.5 3.25 11.7 5.25 11.7 7.75C11.7 8.05 11.7 8.45 11.8 8.75C8.7 8.65 5.1 6.95 3 4.05C1.7 6.35 2.8 8.95 4.3 9.95C3.8 10.05 2.9 9.95 2.5 9.45C2.5 11.05 3.2 13.05 5.7 13.85C5.2 14.15 4.4 14.05 4 13.95C4.1 15.25 5.8 16.95 7.7 16.95C7 17.75 4.8 19.25 2 18.75C3.9 19.95 6.1 20.75 8.5 20.75C15.2 20.75 20.4 14.95 20.1 7.75C20.1 7.75 20.1 7.75 20.1 7.65C20.1 7.65 20.1 7.65 20.1 7.55C20.6 7.15 21.4 6.45 22 5.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.904464e8b2bd3e118808b139f7779796.svg";
export { ForwardRef as ReactComponent };